import { useGrowlers, GrowlerConfig } from "@spscommerce/ds-react";
import { CommercePlatform } from "@spscommerce/services";
import React from "react";
import {
    HashRouter as Router,
    Redirect,
    Route,
    Switch,
    RouteProps,
    useHistory,
} from "react-router-dom";

import { ROUTES } from "./Routes";
import { AuthService, RedirectService, InviteService } from "./utils";

export interface AppProps {
    env: string;
    platform: CommercePlatform;
    authService: AuthService;
    redirectService: RedirectService;
    inviteService: InviteService;
}

export type AppRouteProps = AppProps &
    RouteProps & {
        createGrowler: (config: GrowlerConfig) => void;
    };

export function App({ env, platform, authService, redirectService, inviteService }: AppProps) {
    const [growlers, createGrowler] = useGrowlers();

    return (
        <div className="sps-public-app">
            {growlers()}
            <Router>
                <SpsCommercePlatformUrlizer platform={platform}>
                    <Switch>
                        <Route exact path="/" render={() => <Redirect to={ROUTES[0].path} />} />
                        {ROUTES.map((route, i) => (
                            <Route
                                key={i}
                                exact
                                path={route.path}
                                render={(routeProps: any) => (
                                    <route.component
                                        {...{
                                            env,
                                            platform,
                                            createGrowler,
                                            authService,
                                            redirectService,
                                            inviteService,
                                            ...routeProps,
                                        }}
                                    />
                                )}
                            />
                        ))}
                    </Switch>
                </SpsCommercePlatformUrlizer>
            </Router>
        </div>
    );
}

export interface SpsCommercePlatformUrlizerProps {
    children: JSX.Element;
    platform: CommercePlatform;
}

export function SpsCommercePlatformUrlizer({
    children,
    platform,
}: SpsCommercePlatformUrlizerProps) {
    const history = useHistory();
    React.useEffect(() => {
        return history.listen(() => {
            platform.updateState();
        });
    }, []); // eslint-disable-line
    return <>{children}</>;
}
